export default "__VITE_PUBLIC_ASSET__6453c4c3__"